export const ALIS_SECURED_INBOUND_CONVERSATION={
  "id": "",
  "participants": [
    {
      "id": "",
      "name": "Half Day IL",
      "address": "",
      "startTime": "",
      "connectedTime": "",
      "endTime": "",
      "purpose": "customer",
      "state": "connected",
      "direction": "inbound",
      "disconnectType": "peer",
      "held": false,
      "wrapupRequired": false,
      "mediaRoles": [
        "full"
      ],
      "queue": {
        "id": "9f7d2a94-24c5-4898-9849-4ae3dcfbd558",
        "selfUri": "/api/v2/routing/queues/9f7d2a94-24c5-4898-9849-4ae3dcfbd558"
      },
      "attributes": {
        "GCR_Visibility": "true",
        "Timezone": "US-Central",
        "CS_XFER_USER_ID": "",
        "UIID": "61IN",
        "Debug_Inbound_EmergencyCheck": "INFO - No Active Emergency",
        "Debug_Inbound_RoutingLookup": "INFO - Key found in GenRoute Table",
        "Treatment_QCAPThreshold": "EWT:1800",
        "Schedule_CurrentUTCOffset": "-300",
        "Treatment_EmergencyActions": "",
        "AccessDirectCall": "true",
        "GCR_Color": "#FFFF99",
        "Schedule_ActiveScheduleTag": "Default",
        "CS_INIT_REP_ID": "",
        "IS_CS_CUSTOMER_ID_ENCRYPTED": "true",
        "ConversationID": "",
        "SKILL_NAME": "",
        "PPT-NAME": "",
        "PINV": "S",
        "ENC_CS_CUSTOMER_ID": "",
        "Debug_InQueue_StartingPIQ": "1",
        "GCR_Ind": "This call is recorded.",
        "EMP": "",
        "Participant_ANI": "",
        "QUEUE_NAME": "",
        "IVR Division Not Updated": "IVR Division Update Workflow ENV is not matching with Originating IVR Env.",
        "ServiceID": "",
        "LAST4_ID": "",
        "Schedule_ImmediateCBEnabled": "true",
        "Debug_UUIReceived": "*****0036      1000S00095      m",
        "ScreenPopName": "Inbound Script v2.1",
        "Debug_InQueue_StartingEWT": "0",
        "Key": "+18004898708_1000",
        "GCR_Indicator": "This call is recorded.",
        "bSurveyEnabled": "false",
        "Treatment_InQueueActions": "Discover_1stQ_8a_6p_CT~Music::2~Common_2ndQ~Music::2~Loop:3:1~ForceICB~Disconnect",
        "SkillName": "",
        "Treatment_QueueParameters": "",
        "AgentLegInvoked": "YES",
        "COE_Sec_IsAttempted": "true",
        "Language": "English",
        "Debug_CM-Schedule_ClosedStatus": "INFO - Schedule is: open Closed Processing Skipped",
        "TrackingWorkflow": "Triggered",
        "QueueName": "",
        "Treatment_QCAPActions": "Discover_1stQ_8a_6p_CT~Disconnect",
        "Caller_PINV": "S",
        "Schedule_ScheduledCBEnabled": "false",
        "Debug_Verbose": "true",
        "IVR_NOT_Tracked": "Workflow ENV is not matching with Originating IVR Env.",
        "IsSurveyPreQMsgPlayed": "",
        "UDP_GBL_ID": "66e1551ce79fa840ee7f1707",
        "eg_km_portalname": "ClientID-00095",
        "Treatment_Parameters": "PadEWT:20|InQEmergChkTimer:300",
        "SetDivisionUpdateWorkflow": "Triggered",
        "GCR_Status": "GC_ANI_Y_REC",
        "Treatment_EmergencyGroups": "",
        "scriptId": "45d0bc96-483a-459b-a4d3-94a6d23b13fd",
        "Debug_InQueue_QCAPViolation": "INFO - No QCAP Violation - Normal Processing",
        "UII_Creation_Status": "Empty - GC Created using API",
        "MORE_IND": "m",
        "Config_DesktopIndicator": "CarePortal",
        "CS_CLIENT_ID": ""
      },
      "provider": "Edge",
      "externalContact": {
        "id": "0181f4c7-ef54-4abd-bd15-f03c876c12e1",
        "selfUri": "/api/v2/externalcontacts/contacts/0181f4c7-ef54-4abd-bd15-f03c876c12e1"
      },
      "externalContactInitialDivisionId": "*",
      "muted": false,
      "confined": false,
      "recording": false,
      "recordingState": "none",
      "recordersState": {
        "adhocState": "NONE",
        "customerExperienceState": "NONE",
        "agentExperienceState": "NONE"
      },
      "ani": "tel:+12242744093",
      "dnis": "tel:+18478869364",
      "securePause": false
    },
    
  ],
  "otherMediaUris": [],
  "recordingState": "none",
  "securePause": false,
  "selfUri": "/api/v2/conversations/calls/31d3e702-9682-4c38-9d90-4e55385c57a1"
};
export const ALIS_UNSECURED_INBOUND_CONVERSATION={
    "id": "2db2fd2c-a0fd-4563-b2c2-47df5e45919f",
    "participants": [
        {
            "id": "fee2effe-25c3-4839-94c7-ab7d66bcea70",
            "name": "Half Day IL",
            "address": "tel:+12242744093",
            "startTime": "2025-09-23T13:32:42.394Z",
            "connectedTime": "2025-09-23T13:32:42.461Z",
            "purpose": "customer",
            "state": "connected",
            "direction": "inbound",
            "held": false,
            "wrapupRequired": false,
            "mediaRoles": [
                "full"
            ],
            "queue": {
                "id": "9f7d2a94-24c5-4898-9849-4ae3dcfbd558",
                "selfUri": "/api/v2/routing/queues/9f7d2a94-24c5-4898-9849-4ae3dcfbd558"
            },
            "attributes": {
                "GCR_Visibility": "true",
                "Timezone": "US-Central",
                "CS_XFER_USER_ID": "",
                "UIID": "621S",
                "Debug_Inbound_EmergencyCheck": "INFO - No Active Emergency",
                "Debug_Inbound_RoutingLookup": "INFO - Key found in GenRoute Table",
                "Treatment_QCAPThreshold": "EWT:1800",
                "Schedule_CurrentUTCOffset": "-300",
                "Treatment_EmergencyActions": "",
                "AccessDirectCall": "true",
                "GCR_Color": "#FFFF99",
                "Schedule_ActiveScheduleTag": "Default",
                "CS_INIT_REP_ID": "",
                "IS_CS_CUSTOMER_ID_ENCRYPTED": "true",
                "ConversationID": "",
                "SKILL_NAME": "",
                "PPT-NAME": "",
                "PINV": "",
                "ENC_CS_CUSTOMER_ID": "",
                "Debug_InQueue_StartingPIQ": "1",
                "GCR_Ind": "This call is recorded.",
                "EMP": "Terminated",
                "Participant_ANI": "",
                "QUEUE_NAME": "",
                "ServiceID": "",
                "LAST4_ID": "",
                "Schedule_ImmediateCBEnabled": "true",
                "Debug_UUIReceived": "*****0036      1000U00095      m",
                "ScreenPopName": "Inbound Script v2.1",
                "Debug_InQueue_StartingEWT": "0",
                "Key": "+18004898708_1000",
                "GCR_Indicator": "This call is recorded.",
                "bSurveyEnabled": "false",
                "Treatment_InQueueActions": "Discover_1stQ_8a_6p_CT~Music::2~Common_2ndQ~Music::2~Loop:3:1~ForceICB~Disconnect",
                "SkillName": "P00095_Premier_Cspro",
                "Treatment_QueueParameters": "",
                "AgentLegInvoked": "YES",
                "COE_Sec_IsAttempted": "true",
                "Language": "English",
                "Debug_CM-Schedule_ClosedStatus": "INFO - Schedule is: open Closed Processing Skipped",
                "TrackingWorkflow": "Triggered",
                "QueueName": "",
                "Treatment_QCAPActions": "Discover_1stQ_8a_6p_CT~Disconnect",
                "Caller_PINV": "U",
                "Schedule_ScheduledCBEnabled": "false",
                "Debug_Verbose": "true",
                "IVR_NOT_Tracked": "Workflow ENV is not matching with Originating IVR Env.",
                "IsSurveyPreQMsgPlayed": "",
                "UDP_GBL_ID": "66e1551ce79fa840ee7f1707",
                "eg_km_portalname": "ClientID-00095",
                "Treatment_Parameters": "PadEWT:20|InQEmergChkTimer:300",
                "GCR_Status": "GC_ANI_Y_REC",
                "Treatment_EmergencyGroups": "",
                "scriptId": "45d0bc96-483a-459b-a4d3-94a6d23b13fd",
                "Debug_InQueue_QCAPViolation": "INFO - No QCAP Violation - Normal Processing",
                "UII_Creation_Status": "Empty - GC Created using API",
                "MORE_IND": "m",
                "Config_DesktopIndicator": "CarePortal",
                "CS_CLIENT_ID": ""
            },
            "provider": "Edge",
            "externalContact": {
                "id": "0181f4c7-ef54-4abd-bd15-f03c876c12e1",
                "selfUri": "/api/v2/externalcontacts/contacts/0181f4c7-ef54-4abd-bd15-f03c876c12e1"
            },
            "externalContactInitialDivisionId": "*",
            "muted": false,
            "confined": false,
            "recording": true,
            "recordingState": "active",
            "ani": "tel:+12242744093",
            "dnis": "tel:+18478869364",
            "securePause": false
        },
       
    ],
    "otherMediaUris": [],
    "recordingState": "active",
    "securePause": false,
    "selfUri": "/api/v2/conversations/calls/2db2fd2c-a0fd-4563-b2c2-47df5e45919f"
};
export const ALIS_UNKNOWN_INBOUND_CONVERSATION={
    "id": "847d2efa-d824-4942-9baf-a2f72d6ff071",
    "participants": [
        {
            "id": "5f5901fe-cdb0-4d22-a517-2a6b5d4c4e98",
            "name": "Half Day IL",
            "address": "tel:+12242744093",
            "startTime": "2025-09-23T13:36:14.054Z",
            "connectedTime": "2025-09-23T13:36:14.156Z",
            "purpose": "customer",
            "state": "connected",
            "direction": "inbound",
            "held": false,
            "wrapupRequired": false,
            "mediaRoles": [
                "full"
            ],
            "queue": {
                "id": "9f7d2a94-24c5-4898-9849-4ae3dcfbd558",
                "selfUri": "/api/v2/routing/queues/9f7d2a94-24c5-4898-9849-4ae3dcfbd558"
            },
            "attributes": {
                "GCR_Visibility": "true",
                "Timezone": "US-Central",
                "UIID": "621T",
                "Debug_Inbound_EmergencyCheck": "INFO - No Active Emergency",
                "Debug_Inbound_RoutingLookup": "INFO - Key found in GenRoute Table",
                "Treatment_QCAPThreshold": "EWT:1800",
                "Schedule_CurrentUTCOffset": "-300",
                "Treatment_EmergencyActions": "",
                "AccessDirectCall": "true",
                "GCR_Color": "#FFFF99",
                "Schedule_ActiveScheduleTag": "Default",
                "IS_CS_CUSTOMER_ID_ENCRYPTED": "true",
                "ConversationID": "847d2efa-d824-4942-9baf-a2f72d6ff071",
                "SKILL_NAME": "P00095_Premier_Cspro",
                "PINV": "",
                "ENC_CS_CUSTOMER_ID": "",
                "Debug_InQueue_StartingPIQ": "1",
                "GCR_Ind": "This call is recorded.",
                "Participant_ANI": "tel:+12242744093",
                "QUEUE_NAME": "",
                "ServiceID": "1000",
                "LAST4_ID": "",
                "Schedule_ImmediateCBEnabled": "true",
                "Debug_UUIReceived": "*****45678912341000U00095      m",
                "ScreenPopName": "Inbound Script v2.1",
                "Debug_InQueue_StartingEWT": "2",
                "Key": "+18004898708_1000",
                "GCR_Indicator": "This call is recorded.",
                "bSurveyEnabled": "false",
                "Treatment_InQueueActions": "Discover_1stQ_8a_6p_CT~Music::2~Common_2ndQ~Music::2~Loop:3:1~ForceICB~Disconnect",
                "SkillName": "",
                "Treatment_QueueParameters": "",
                "AgentLegInvoked": "YES",
                "COE_Sec_IsAttempted": "true",
                "Language": "English",
                "Debug_CM-Schedule_ClosedStatus": "INFO - Schedule is: open Closed Processing Skipped",
                "QueueName": "",
                "Treatment_QCAPActions": "Discover_1stQ_8a_6p_CT~Disconnect",
                "Caller_PINV": "U",
                "Schedule_ScheduledCBEnabled": "false",
                "Debug_Verbose": "true",
                "IsSurveyPreQMsgPlayed": "",
                "UDP_GBL_ID": "",
                "eg_km_portalname": "ClientID-00095",
                "Treatment_Parameters": "PadEWT:20|InQEmergChkTimer:300",
                "GCR_Status": "GC_ANI_Y_REC",
                "Treatment_EmergencyGroups": "",
                "scriptId": "45d0bc96-483a-459b-a4d3-94a6d23b13fd",
                "Debug_InQueue_QCAPViolation": "INFO - No QCAP Violation - Normal Processing",
                "UII_Creation_Status": "Empty - GC Created using API",
                "MORE_IND": "m",
                "Config_DesktopIndicator": "CarePortal",
                "CS_CLIENT_ID": ""
            },
            "provider": "Edge",
            "externalContact": {
                "id": "0181f4c7-ef54-4abd-bd15-f03c876c12e1",
                "selfUri": "/api/v2/externalcontacts/contacts/0181f4c7-ef54-4abd-bd15-f03c876c12e1"
            },
            "externalContactInitialDivisionId": "*",
            "muted": false,
            "confined": false,
            "recording": true,
            "recordingState": "active",
            "ani": "tel:+12242744093",
            "dnis": "tel:+18478869364",
            "securePause": false
        },
       
    ],
    "otherMediaUris": [],
    "recordingState": "active",
    "securePause": false,
    "selfUri": "/api/v2/conversations/calls/847d2efa-d824-4942-9baf-a2f72d6ff071"
};
export const ALIS_OUTBOUND_CONVERSATION={
    "id": "f47a3395-f2de-4c28-9949-10e944cac86d",
    "participants": [
        {
            "id": "3ff17820-f623-47b6-ad9d-52461192d972",
            "address": "sip:624ab0d8ecf9671cfda78162+alightsolutions-dev.orgspan.com@localhost",
            "startTime": "2025-09-23T13:01:54.235Z",
            "connectedTime": "2025-09-23T13:02:02.261Z",
            "purpose": "agent",
            "state": "connected",
            "direction": "outbound",
            "held": false,
            "wrapupRequired": true,
            "wrapupPrompt": "timeout",
            "mediaRoles": [
                "full"
            ],
            "user": {
                "id": "1488b55c-aa19-41f3-ae1d-44dca1d9b534",
                "selfUri": "/api/v2/users/1488b55c-aa19-41f3-ae1d-44dca1d9b534"
            },
            "queue": {
                "id": "e368a96d-cf87-4bbc-8bb0-146747bada79",
                "selfUri": "/api/v2/routing/queues/e368a96d-cf87-4bbc-8bb0-146747bada79"
            },
            "attributes": {
                "GCRStatus": "",
                "GCRDelCallRec": "false"
            },
            "script": {
                "id": "c970b669-1e1d-471e-93f8-183e927b5858",
                "selfUri": "/api/v2/scripts/c970b669-1e1d-471e-93f8-183e927b5858"
            },
            "wrapupTimeoutMs": 10000,
            "provider": "Edge",
            "muted": true,
            "confined": false,
            "recording": false,
            "recordingState": "none",
            "ani": "sip:624ab0d8ecf9671cfda78162+alightsolutions-dev.orgspan.com@localhost",
            "dnis": "tel:+919666365604",
            "securePause": false
        },
        {
            "id": "2112418f-cb35-46c8-97eb-e8185b1dcf0a",
            "name": "Mobile Number, India",
            "address": "tel:+919666365604",
            "startTime": "2025-09-23T13:01:56.316Z",
            "connectedTime": "2025-09-23T13:02:02.258Z",
            "purpose": "customer",
            "state": "connected",
            "direction": "outbound",
            "held": false,
            "wrapupRequired": false,
            "mediaRoles": [
                "full"
            ],
            "queue": {
                "id": "e368a96d-cf87-4bbc-8bb0-146747bada79",
                "selfUri": "/api/v2/routing/queues/e368a96d-cf87-4bbc-8bb0-146747bada79"
            },
            "attributes": {
                "IS_CS_CUSTOMER_ID_ENCRYPTED": "",
                "ROLE_TYPE": "",
                "CS_XFER_USER_ID": "",
                "PPT-NAME": "",
                "PINV": "U",
                "CS_CALLER_TYPE": "",
                "ENC_CS_CUSTOMER_ID": "",
                "CUSTOMER_TYPE": "",
                "EMP": "",
                "UDP_GBL_ID": "",
                "QUEUE_NAME": "",
                "CS_INIT_REP_ID": "",
                "CS_CLIENT_ID": ""
            },
            "provider": "Edge",
            "externalContact": {
                "id": "15529a06-771c-4d95-87bf-d55aee46cad2",
                "selfUri": "/api/v2/externalcontacts/contacts/15529a06-771c-4d95-87bf-d55aee46cad2"
            },
            "externalContactInitialDivisionId": "*",
            "peer": "38bf2a9b-1727-4e4b-b80a-357f9d46b3f9",
            "muted": false,
            "confined": false,
            "recording": true,
            "recordingState": "active",
            "ani": "sip:+18473834985@10.42.230.184;user=phone",
            "dnis": "tel:+919666365604",
            "securePause": false
        }
    ],
    "otherMediaUris": [],
    "recentTransfers": [],
    "utilizationLabelId": "631f0939-be32-495a-baf9-970abb039192",
    "recordingState": "active",
    "securePause": false,
    "selfUri": "/api/v2/conversations/calls/f47a3395-f2de-4c28-9949-10e944cac86d"
};
export const ALIS_UNKNOWN_OUTBOUND_CONVERSATION={
    "id": "452fa03a-ce3e-4c21-9ce9-6bca0e8ab47c",
    "participants": [
        {
            "id": "7b1d1780-c80e-4988-9652-0d9633027476",
            "address": "sip:624ab0d8ecf9671cfda78162+alightsolutions-dev.orgspan.com@localhost",
            "startTime": "2025-09-23T12:55:17.445Z",
            "connectedTime": "2025-09-23T12:55:25.645Z",
            "purpose": "agent",
            "state": "connected",
            "direction": "outbound",
            "held": false,
            "wrapupRequired": true,
            "wrapupPrompt": "timeout",
            "mediaRoles": [
                "full"
            ],
            "user": {
                "id": "1488b55c-aa19-41f3-ae1d-44dca1d9b534",
                "selfUri": "/api/v2/users/1488b55c-aa19-41f3-ae1d-44dca1d9b534"
            },
            "queue": {
                "id": "3c9779c9-a94b-45ca-89c0-b0e3fde9fd5a",
                "selfUri": "/api/v2/routing/queues/3c9779c9-a94b-45ca-89c0-b0e3fde9fd5a"
            },
            "attributes": {
                "GCRStatus": "",
                "GCRDelCallRec": "false"
            },
            "script": {
                "id": "c970b669-1e1d-471e-93f8-183e927b5858",
                "selfUri": "/api/v2/scripts/c970b669-1e1d-471e-93f8-183e927b5858"
            },
            "wrapupTimeoutMs": 10000,
            "provider": "Edge",
            "screenRecordingState": "active",
            "muted": true,
            "confined": false,
            "recording": false,
            "recordingState": "none",
            "ani": "sip:624ab0d8ecf9671cfda78162+alightsolutions-dev.orgspan.com@localhost",
            "dnis": "tel:+919666365604",
            "securePause": false
        },
        {
            "id": "8444263e-2ecd-420a-94f9-254287a22800",
            "name": "Mobile Number, India",
            "address": "tel:+919666365604",
            "startTime": "2025-09-23T12:55:19.176Z",
            "connectedTime": "2025-09-23T12:55:25.642Z",
            "purpose": "customer",
            "state": "connected",
            "direction": "outbound",
            "held": false,
            "wrapupRequired": false,
            "mediaRoles": [
                "full"
            ],
            "queue": {
                "id": "3c9779c9-a94b-45ca-89c0-b0e3fde9fd5a",
                "selfUri": "/api/v2/routing/queues/3c9779c9-a94b-45ca-89c0-b0e3fde9fd5a"
            },
            "attributes": {
                "QUEUE_NAME": "",
                "CS_CLIENT_ID": ""
            },
            "provider": "Edge",
            "externalContact": {
                "id": "15529a06-771c-4d95-87bf-d55aee46cad2",
                "selfUri": "/api/v2/externalcontacts/contacts/15529a06-771c-4d95-87bf-d55aee46cad2"
            },
            "externalContactInitialDivisionId": "*",
            "peer": "aca92141-fa9c-44d8-acc7-830b4abac101",
            "muted": false,
            "confined": false,
            "recording": true,
            "recordingState": "active",
            "ani": "sip:+18473834985@10.42.230.184;user=phone",
            "dnis": "tel:+919666365604",
            "securePause": false
        }
    ],
    "otherMediaUris": [],
    "recentTransfers": [],
    "utilizationLabelId": "631f0939-be32-495a-baf9-970abb039192",
    
    "recordingState": "active",
    "securePause": false,
    "selfUri": "/api/v2/conversations/calls/452fa03a-ce3e-4c21-9ce9-6bca0e8ab47c"
};
export const ALIS_UNSECURE_CALLBACK_CONVERSATION={
    "id": "7e166409-4245-48a9-8348-5a08d85f871c",
    "participants": [
        {
            "id": "3b580ff9-c8bf-4aee-910e-002305fa7c7a",
            "name": "IVR_CarePortal_UUI_Simulator_v0.1_QC",
            "address": "sip:a44ea784-e366-40d0-bf0a-2c88946ad727@127.0.0.1;language=en-US;user=ivr",
            "startTime": "2025-09-24T04:52:41.545Z",
            "connectedTime": "2025-09-24T04:52:41.562Z",
            "endTime": "2025-09-24T04:52:49.422Z",
            "purpose": "ivr",
            "state": "terminated",
            "direction": "inbound",
            "disconnectType": "transfer",
            "held": false,
            "wrapupRequired": false,
            "mediaRoles": [],
            "attributes": {},
            "provider": "Edge",
            "peer": "24441f71-d597-3eb9-9737-a8f6c9c11150",
            "muted": false,
            "confined": false,
            "recording": false,
            "recordingState": "none",
            "ani": "tel:+12242744093",
            "dnis": "sip:a44ea784-e366-40d0-bf0a-2c88946ad727@127.0.0.1;language=en-US;user=ivr",
            "securePause": false
        },
        {
            "id": "0f5416ba-141f-420b-944a-3c2b8dacc362",
            "name": "ALIS_Standard_InboundFlow_v25.08_QA",
            "address": "sip:9c556a47-1403-4996-b8b8-1ee228debc3e@127.0.0.1;language=en-US;user=ivr",
            "startTime": "2025-09-24T04:52:49.407Z",
            "connectedTime": "2025-09-24T04:52:49.419Z",
            "endTime": "2025-09-24T04:53:06.748Z",
            "purpose": "ivr",
            "state": "terminated",
            "direction": "inbound",
            "disconnectType": "transfer",
            "held": false,
            "wrapupRequired": false,
            "mediaRoles": [],
            "attributes": {},
            "provider": "Edge",
            "peer": "24441f71-d597-3eb9-9737-a8f6c9c11150",
            "muted": false,
            "confined": false,
            "recording": false,
            "recordingState": "none",
            "ani": "tel:+12242744093",
            "dnis": "sip:9c556a47-1403-4996-b8b8-1ee228debc3e@127.0.0.1;language=en-US;user=ivr",
            "uuiData": "000000036      1000U00095      m",
            "securePause": false
        },
        {
            "id": "40237463-dbfc-46c7-9598-02be96dcc25c",
            "name": "00095_Premier_Cspro",
            "address": "sip:9f7d2a94-24c5-4898-9849-4ae3dcfbd558@127.0.0.1;language=en-US;src=https://edge-proxy.us-east-1.mypurecloud.com/connector/v1/organizations/2ef3f876-3ce1-4d80-8f62-72341e73fd02/defaults/ivr/2cbc3f75-2e51-4093-98a8-34d4fe3b467c/defaultentrypoint.vxml;user=acd",
            "startTime": "2025-09-24T04:53:06.794Z",
            "connectedTime": "2025-09-24T04:53:06.839Z",
            "endTime": "2025-09-24T04:54:34.455Z",
            "purpose": "acd",
            "state": "terminated",
            "direction": "inbound",
            "disconnectType": "system",
            "held": false,
            "wrapupRequired": false,
            "mediaRoles": [],
            "queue": {
                "id": "9f7d2a94-24c5-4898-9849-4ae3dcfbd558",
                "selfUri": "/api/v2/routing/queues/9f7d2a94-24c5-4898-9849-4ae3dcfbd558"
            },
            "attributes": {
                "ivr.Skills": "10612c10-3f00-4011-a938-a5de8a47cefb"
            },
            "provider": "Edge",
            "peer": "24441f71-d597-3eb9-9737-a8f6c9c11150",
            "conversationRoutingData": {
                "queue": {
                    "id": "9f7d2a94-24c5-4898-9849-4ae3dcfbd558",
                    "selfUri": "/api/v2/routing/queues/9f7d2a94-24c5-4898-9849-4ae3dcfbd558"
                },
                "priority": 0,
                "skills": [
                    {
                        "id": "10612c10-3f00-4011-a938-a5de8a47cefb",
                        "selfUri": "/api/v2/routing/skills/10612c10-3f00-4011-a938-a5de8a47cefb"
                    }
                ],
                "scoredAgents": [],
                "label": "631f0939-be32-495a-baf9-970abb039192"
            },
            "muted": false,
            "confined": false,
            "recording": false,
            "recordingState": "none",
            "ani": "tel:+12242744093",
            "dnis": "sip:9f7d2a94-24c5-4898-9849-4ae3dcfbd558@127.0.0.1;language=en-US;src=https://edge-proxy.us-east-1.mypurecloud.com/connector/v1/organizations/2ef3f876-3ce1-4d80-8f62-72341e73fd02/defaults/ivr/2cbc3f75-2e51-4093-98a8-34d4fe3b467c/defaultentrypoint.vxml;user=acd",
            "uuiData": "000000036      1000U00095      m",
            "securePause": false
        },
        {
            "id": "e4585d88-b234-4723-965c-6fefded58dd9",
            "address": "sip:624ab0d8ecf9671cfda78162+alightsolutions-dev.orgspan.com@localhost",
            "startTime": "2025-09-24T04:54:40.066Z",
            "connectedTime": "2025-09-24T04:54:55.862Z",
            "purpose": "agent",
            "state": "connected",
            "direction": "outbound",
            "held": false,
            "wrapupRequired": true,
            "wrapupPrompt": "optional",
            "mediaRoles": [
                "full"
            ],
            "user": {
                "id": "1488b55c-aa19-41f3-ae1d-44dca1d9b534",
                "selfUri": "/api/v2/users/1488b55c-aa19-41f3-ae1d-44dca1d9b534"
            },
            "queue": {
                "id": "9f7d2a94-24c5-4898-9849-4ae3dcfbd558",
                "selfUri": "/api/v2/routing/queues/9f7d2a94-24c5-4898-9849-4ae3dcfbd558"
            },
            "attributes": {},
            "script": {
                "id": "c970b669-1e1d-471e-93f8-183e927b5858",
                "selfUri": "/api/v2/scripts/c970b669-1e1d-471e-93f8-183e927b5858"
            },
            "alertingTimeoutMs": 30000,
            "provider": "Edge",
            "conversationRoutingData": {
                "priority": 0,
                "skills": [],
                "scoredAgents": []
            },
            "muted": true,
            "confined": false,
            "recording": false,
            "recordingState": "none",
            "ani": "sip:624ab0d8ecf9671cfda78162+alightsolutions-dev.orgspan.com@localhost",
            "dnis": "tel:+919666365604",
            "securePause": false
        },
        {
            "id": "b74083fc-0ea0-4025-b20f-ae2e8ef8e89b",
            "name": "Half Day IL",
            "address": "tel:+919666365604",
            "startTime": "2025-09-24T04:52:41.533Z",
            "connectedTime": "2025-09-24T04:54:55.858Z",
            "purpose": "customer",
            "state": "connected",
            "direction": "outbound",
            "held": false,
            "wrapupRequired": false,
            "mediaRoles": [
                "full"
            ],
            "queue": {
                "id": "9f7d2a94-24c5-4898-9849-4ae3dcfbd558",
                "selfUri": "/api/v2/routing/queues/9f7d2a94-24c5-4898-9849-4ae3dcfbd558"
            },
            "attributes": {
                "GCR_Visibility": "true",
                "Timezone": "US-Central",
                "CS_XFER_USER_ID": "",
                "UIID": "622w",
                "Debug_Inbound_EmergencyCheck": "INFO - No Active Emergency",
                "Debug_Inbound_RoutingLookup": "INFO - Key found in GenRoute Table",
                "Treatment_QCAPThreshold": "EWT:1800",
                "Schedule_CurrentUTCOffset": "-300",
                "Treatment_EmergencyActions": "",
                "AccessDirectCall": "true",
                "GCR_Color": "#FFFF99",
                "Schedule_ActiveScheduleTag": "Default",
                "CS_INIT_REP_ID": "",
                "IS_CS_CUSTOMER_ID_ENCRYPTED": "true",
                "ConversationID": "7e166409-4245-48a9-8348-5a08d85f871c",
                "SKILL_NAME": "P00095_Premier_Cspro",
                "PPT-NAME": "",
                "PINV": "",
                "ENC_CS_CUSTOMER_ID": "",
                "Debug_InQueue_StartingPIQ": "1",
                "GCR_Ind": "This call is recorded.",
                "EMP": "Terminated",
                "Participant_ANI": "",
                "QUEUE_NAME": "",
                "IVR Division Not Updated": "IVR Division Update Workflow ENV is not matching with Originating IVR Env.",
                "ServiceID": "1000",
                "Callback_Channel": "voice_ASAP",
                "Debug_ImmediateCallbackCM_GetActiveCallbacks": "INFO - 0 active callbacks found",
                "LAST4_ID": "",
                "Schedule_ImmediateCBEnabled": "true",
                "Debug_UUIReceived": "*****0036      1000U00095      m",
                "ScreenPopName": "Inbound Script v2.1",
                "Debug_InQueue_StartingEWT": "Not Available",
                "Key": "+18004898708_1000",
                "GCR_Indicator": "This call is recorded.",
                "bSurveyEnabled": "false",
                "Treatment_InQueueActions": "Discover_1stQ_8a_6p_CT~Music::2~Common_2ndQ~Music::2~Loop:3:1~ForceICB~Disconnect",
                "SkillName": "P00095_Premier_Cspro",
                "Treatment_QueueParameters": "",
                "AgentLegInvoked": "YES",
                "COE_Sec_IsAttempted": "true",
                "Language": "English",
                "Debug_CM-Schedule_ClosedStatus": "INFO - Schedule is: open Closed Processing Skipped",
                "TrackingWorkflow": "Triggered",
                "Debug_ImmediateCallbackCM_Status": "Callback to +919666365604 created in queue 00095_Premier_Cspro",
                "QueueName": "",
                "Callback_Created_Time_UTC": "2025-09-24T04:54:26.267Z",
                "Treatment_QCAPActions": "Discover_1stQ_8a_6p_CT~Disconnect",
                "Caller_PINV": "U",
                "Schedule_ScheduledCBEnabled": "false",
                "Debug_Verbose": "true",
                "IVR_NOT_Tracked": "Workflow ENV is not matching with Originating IVR Env.",
                "IsSurveyPreQMsgPlayed": "",
                "UDP_GBL_ID": "",
                "eg_km_portalname": "ClientID-00095",
                "Treatment_Parameters": "PadEWT:20|InQEmergChkTimer:300",
                "SetDivisionUpdateWorkflow": "Triggered",
                "GCR_Status": "GC_ANI_Y_REC",
                "Treatment_EmergencyGroups": "",
                "scriptId": "45d0bc96-483a-459b-a4d3-94a6d23b13fd",
                "Debug_InQueue_QCAPViolation": "INFO - No QCAP Violation - Normal Processing",
                "UII_Creation_Status": "Empty - GC Created using API",
                "MORE_IND": "m",
                "Config_DesktopIndicator": "CarePortal",
                "CS_CLIENT_ID": ""
            },
            "provider": "Edge",
            "externalContact": {
                "id": "0181f4c7-ef54-4abd-bd15-f03c876c12e1",
                "selfUri": "/api/v2/externalcontacts/contacts/0181f4c7-ef54-4abd-bd15-f03c876c12e1"
            },
            "externalContactInitialDivisionId": "*",
            "peer": "d293db18-b65e-47b5-a8cf-1ff7821bbf4a",
            "muted": false,
            "confined": false,
            "recording": true,
            "recordingState": "active",
            "ani": "tel:+12242744093",
            "dnis": "tel:+18478869364",
            "securePause": false
        },
        {
            "id": "b74083fc-0ea0-4025-b20f-ae2e8ef8e89b",
            "name": "Half Day IL",
            "address": "tel:+919666365604",
            "startTime": "2025-09-24T04:52:41.533Z",
            "connectedTime": "2025-09-24T04:52:41.653Z",
            "endTime": "2025-09-24T04:54:34.459Z",
            "purpose": "customer",
            "state": "terminated",
            "direction": "inbound",
            "disconnectType": "peer",
            "held": false,
            "wrapupRequired": false,
            "mediaRoles": [
                "full"
            ],
            "queue": {
                "id": "9f7d2a94-24c5-4898-9849-4ae3dcfbd558",
                "selfUri": "/api/v2/routing/queues/9f7d2a94-24c5-4898-9849-4ae3dcfbd558"
            },
            "attributes": {
                "GCR_Visibility": "true",
                "Timezone": "US-Central",
                "CS_XFER_USER_ID": "A1059029",
                "UIID": "622w",
                "Debug_Inbound_EmergencyCheck": "INFO - No Active Emergency",
                "Debug_Inbound_RoutingLookup": "INFO - Key found in GenRoute Table",
                "Treatment_QCAPThreshold": "EWT:1800",
                "Schedule_CurrentUTCOffset": "-300",
                "Treatment_EmergencyActions": "",
                "AccessDirectCall": "true",
                "GCR_Color": "#FFFF99",
                "Schedule_ActiveScheduleTag": "Default",
                "CS_INIT_REP_ID": "A1059029",
                "IS_CS_CUSTOMER_ID_ENCRYPTED": "true",
                "ConversationID": "7e166409-4245-48a9-8348-5a08d85f871c",
                "SKILL_NAME": "P00095_Premier_Cspro",
                "PPT-NAME": "STUART MARZINSKI",
                "PINV": "U",
                "ENC_CS_CUSTOMER_ID": "yhyku+pM8D47VFmkiEMkdw==",
                "Debug_InQueue_StartingPIQ": "1",
                "GCR_Ind": "This call is recorded.",
                "EMP": "Terminated",
                "Participant_ANI": "tel:+12242744093",
                "QUEUE_NAME": "00095_Premier_Cspro",
                "IVR Division Not Updated": "IVR Division Update Workflow ENV is not matching with Originating IVR Env.",
                "ServiceID": "1000",
                "Callback_Channel": "voice_ASAP",
                "Debug_ImmediateCallbackCM_GetActiveCallbacks": "INFO - 0 active callbacks found",
                "LAST4_ID": "0036",
                "Schedule_ImmediateCBEnabled": "true",
                "Debug_UUIReceived": "*****0036      1000U00095      m",
                "ScreenPopName": "Inbound Script v2.1",
                "Debug_InQueue_StartingEWT": "Not Available",
                "Key": "+18004898708_1000",
                "GCR_Indicator": "This call is recorded.",
                "bSurveyEnabled": "false",
                "Treatment_InQueueActions": "Discover_1stQ_8a_6p_CT~Music::2~Common_2ndQ~Music::2~Loop:3:1~ForceICB~Disconnect",
                "SkillName": "P00095_Premier_Cspro",
                "Treatment_QueueParameters": "",
                "AgentLegInvoked": "YES",
                "COE_Sec_IsAttempted": "true",
                "Language": "English",
                "Debug_CM-Schedule_ClosedStatus": "INFO - Schedule is: open Closed Processing Skipped",
                "TrackingWorkflow": "Triggered",
                "Debug_ImmediateCallbackCM_Status": "Callback to +919666365604 created in queue 00095_Premier_Cspro",
                "QueueName": "00095_Premier_Cspro",
                "Callback_Created_Time_UTC": "2025-09-24T04:54:26.267Z",
                "Treatment_QCAPActions": "Discover_1stQ_8a_6p_CT~Disconnect",
                "Caller_PINV": "U",
                "Schedule_ScheduledCBEnabled": "false",
                "Debug_Verbose": "true",
                "IVR_NOT_Tracked": "Workflow ENV is not matching with Originating IVR Env.",
                "IsSurveyPreQMsgPlayed": "",
                "UDP_GBL_ID": "66e1551ce79fa840ee7f1707",
                "eg_km_portalname": "ClientID-00095",
                "Treatment_Parameters": "PadEWT:20|InQEmergChkTimer:300",
                "SetDivisionUpdateWorkflow": "Triggered",
                "GCR_Status": "GC_ANI_Y_REC",
                "Treatment_EmergencyGroups": "",
                "scriptId": "45d0bc96-483a-459b-a4d3-94a6d23b13fd",
                "Debug_InQueue_QCAPViolation": "INFO - No QCAP Violation - Normal Processing",
                "UII_Creation_Status": "Empty - GC Created using API",
                "MORE_IND": "m",
                "Config_DesktopIndicator": "CarePortal",
                "CS_CLIENT_ID": "00095"
            },
            "provider": "Edge",
            "externalContact": {
                "id": "0181f4c7-ef54-4abd-bd15-f03c876c12e1",
                "selfUri": "/api/v2/externalcontacts/contacts/0181f4c7-ef54-4abd-bd15-f03c876c12e1"
            },
            "externalContactInitialDivisionId": "*",
            "muted": false,
            "confined": false,
            "recording": false,
            "recordingState": "none",
            "recordersState": {
                "adhocState": "NONE",
                "customerExperienceState": "NONE",
                "agentExperienceState": "NONE"
            },
            "ani": "tel:+12242744093",
            "dnis": "tel:+18478869364",
            "securePause": false
        }
    ],
    "otherMediaUris": [
        "/api/v2/conversations/callbacks/7e166409-4245-48a9-8348-5a08d85f871c"
    ],
    
    "recordingState": "active",
    "securePause": false,
    "selfUri": "/api/v2/conversations/calls/7e166409-4245-48a9-8348-5a08d85f871c"
};
export const ALIS_UNKNOWN_CALLBACK_CONVERSATION={
    "id": "9a136a7d-0247-4712-80c8-801676a8062a",
    "participants": [
        {
            "id": "dac13184-532d-4b58-be1b-509d201dce5e",
            "name": "IVR_CarePortal_UUI_Simulator_v0.1_QC",
            "address": "sip:a44ea784-e366-40d0-bf0a-2c88946ad727@127.0.0.1;language=en-US;user=ivr",
            "startTime": "2025-09-24T04:42:08.223Z",
            "connectedTime": "2025-09-24T04:42:08.234Z",
            "endTime": "2025-09-24T04:42:16.223Z",
            "purpose": "ivr",
            "state": "terminated",
            "direction": "inbound",
            "disconnectType": "transfer",
            "held": false,
            "wrapupRequired": false,
            "mediaRoles": [],
            "attributes": {},
            "provider": "Edge",
            "peer": "877868c1-b01d-33f3-9b50-d2b2f610d7c0",
            "muted": false,
            "confined": false,
            "recording": false,
            "recordingState": "none",
            "ani": "tel:+12242744093",
            "dnis": "sip:a44ea784-e366-40d0-bf0a-2c88946ad727@127.0.0.1;language=en-US;user=ivr",
            "securePause": false
        },
        {
            "id": "7df328fa-900e-4bcc-8876-f7a2d2091cec",
            "name": "ALIS_Standard_InboundFlow_v25.08_QA",
            "address": "sip:9c556a47-1403-4996-b8b8-1ee228debc3e@127.0.0.1;language=en-US;user=ivr",
            "startTime": "2025-09-24T04:42:16.205Z",
            "connectedTime": "2025-09-24T04:42:16.215Z",
            "endTime": "2025-09-24T04:42:30.405Z",
            "purpose": "ivr",
            "state": "terminated",
            "direction": "inbound",
            "disconnectType": "transfer",
            "held": false,
            "wrapupRequired": false,
            "mediaRoles": [],
            "attributes": {},
            "provider": "Edge",
            "peer": "877868c1-b01d-33f3-9b50-d2b2f610d7c0",
            "muted": false,
            "confined": false,
            "recording": false,
            "recordingState": "none",
            "ani": "tel:+12242744093",
            "dnis": "sip:9c556a47-1403-4996-b8b8-1ee228debc3e@127.0.0.1;language=en-US;user=ivr",
            "uuiData": "--12345678912341000U00095      m",
            "securePause": false
        },
        {
            "id": "b0e34517-d5ea-4ff8-9692-bae39c28867f",
            "name": "00095_Premier_Cspro",
            "address": "sip:9f7d2a94-24c5-4898-9849-4ae3dcfbd558@127.0.0.1;language=en-US;src=https://edge-proxy.us-east-1.mypurecloud.com/connector/v1/organizations/2ef3f876-3ce1-4d80-8f62-72341e73fd02/defaults/ivr/2cbc3f75-2e51-4093-98a8-34d4fe3b467c/defaultentrypoint.vxml;user=acd",
            "startTime": "2025-09-24T04:42:30.423Z",
            "connectedTime": "2025-09-24T04:42:30.440Z",
            "endTime": "2025-09-24T04:43:59.234Z",
            "purpose": "acd",
            "state": "terminated",
            "direction": "inbound",
            "disconnectType": "system",
            "held": false,
            "wrapupRequired": false,
            "mediaRoles": [],
            "queue": {
                "id": "9f7d2a94-24c5-4898-9849-4ae3dcfbd558",
                "selfUri": "/api/v2/routing/queues/9f7d2a94-24c5-4898-9849-4ae3dcfbd558"
            },
            "attributes": {
                "ivr.Skills": "10612c10-3f00-4011-a938-a5de8a47cefb"
            },
            "provider": "Edge",
            "peer": "877868c1-b01d-33f3-9b50-d2b2f610d7c0",
            "conversationRoutingData": {
                "queue": {
                    "id": "9f7d2a94-24c5-4898-9849-4ae3dcfbd558",
                    "selfUri": "/api/v2/routing/queues/9f7d2a94-24c5-4898-9849-4ae3dcfbd558"
                },
                "priority": 0,
                "skills": [
                    {
                        "id": "10612c10-3f00-4011-a938-a5de8a47cefb",
                        "selfUri": "/api/v2/routing/skills/10612c10-3f00-4011-a938-a5de8a47cefb"
                    }
                ],
                "scoredAgents": [],
                "label": "631f0939-be32-495a-baf9-970abb039192"
            },
            "muted": false,
            "confined": false,
            "recording": false,
            "recordingState": "none",
            "ani": "tel:+12242744093",
            "dnis": "sip:9f7d2a94-24c5-4898-9849-4ae3dcfbd558@127.0.0.1;language=en-US;src=https://edge-proxy.us-east-1.mypurecloud.com/connector/v1/organizations/2ef3f876-3ce1-4d80-8f62-72341e73fd02/defaults/ivr/2cbc3f75-2e51-4093-98a8-34d4fe3b467c/defaultentrypoint.vxml;user=acd",
            "uuiData": "--12345678912341000U00095      m",
            "securePause": false
        },
        {
            "id": "228fa639-9ac7-44ec-a724-75587c09e4dc",
            "address": "sip:624ab0d8ecf9671cfda78162+alightsolutions-dev.orgspan.com@localhost",
            "startTime": "2025-09-24T04:44:03.017Z",
            "connectedTime": "2025-09-24T04:44:26.795Z",
            "purpose": "agent",
            "state": "connected",
            "direction": "outbound",
            "held": false,
            "wrapupRequired": true,
            "wrapupPrompt": "optional",
            "mediaRoles": [
                "full"
            ],
            "user": {
                "id": "1488b55c-aa19-41f3-ae1d-44dca1d9b534",
                "selfUri": "/api/v2/users/1488b55c-aa19-41f3-ae1d-44dca1d9b534"
            },
            "queue": {
                "id": "9f7d2a94-24c5-4898-9849-4ae3dcfbd558",
                "selfUri": "/api/v2/routing/queues/9f7d2a94-24c5-4898-9849-4ae3dcfbd558"
            },
            "attributes": {},
            "script": {
                "id": "c970b669-1e1d-471e-93f8-183e927b5858",
                "selfUri": "/api/v2/scripts/c970b669-1e1d-471e-93f8-183e927b5858"
            },
            "alertingTimeoutMs": 30000,
            "provider": "Edge",
            "conversationRoutingData": {
                "priority": 0,
                "skills": [],
                "scoredAgents": []
            },
            "muted": true,
            "confined": false,
            "recording": false,
            "recordingState": "none",
            "ani": "sip:624ab0d8ecf9671cfda78162+alightsolutions-dev.orgspan.com@localhost",
            "dnis": "tel:+919666365604",
            "securePause": false
        },
        {
            "id": "6f6b0eb4-2180-4fae-a3ea-000f523ae26c",
            "name": "Half Day IL",
            "address": "tel:+919666365604",
            "startTime": "2025-09-24T04:42:08.205Z",
            "connectedTime": "2025-09-24T04:44:26.792Z",
            "purpose": "customer",
            "state": "connected",
            "direction": "outbound",
            "held": false,
            "wrapupRequired": false,
            "mediaRoles": [
                "full"
            ],
            "queue": {
                "id": "9f7d2a94-24c5-4898-9849-4ae3dcfbd558",
                "selfUri": "/api/v2/routing/queues/9f7d2a94-24c5-4898-9849-4ae3dcfbd558"
            },
            "attributes": {
                "GCR_Visibility": "true",
                "Timezone": "US-Central",
                "UIID": "622s",
                "Debug_Inbound_EmergencyCheck": "INFO - No Active Emergency",
                "Debug_Inbound_RoutingLookup": "INFO - Key found in GenRoute Table",
                "Treatment_QCAPThreshold": "EWT:1800",
                "Schedule_CurrentUTCOffset": "-300",
                "Treatment_EmergencyActions": "",
                "AccessDirectCall": "true",
                "GCR_Color": "#FFFF99",
                "Schedule_ActiveScheduleTag": "Default",
                "IS_CS_CUSTOMER_ID_ENCRYPTED": "true",
                "ConversationID": "9a136a7d-0247-4712-80c8-801676a8062a",
                "SKILL_NAME": "P00095_Premier_Cspro",
                "PINV": "U",
                "ENC_CS_CUSTOMER_ID": "ufZ//052pP19T6vfwx6CYA==",
                "Debug_InQueue_StartingPIQ": "1",
                "GCR_Ind": "This call is recorded.",
                "Participant_ANI": "tel:+12242744093",
                "QUEUE_NAME": "00095_Premier_Cspro",
                "IVR Division Not Updated": "IVR Division Update Workflow ENV is not matching with Originating IVR Env.",
                "ServiceID": "1000",
                "Callback_Channel": "voice_ASAP",
                "Debug_ImmediateCallbackCM_GetActiveCallbacks": "INFO - 0 active callbacks found",
                "LAST4_ID": "1234",
                "Schedule_ImmediateCBEnabled": "true",
                "Debug_UUIReceived": "*****45678912341000U00095      m",
                "ScreenPopName": "Inbound Script v2.1",
                "Debug_InQueue_StartingEWT": "Not Available",
                "Key": "+18004898708_1000",
                "GCR_Indicator": "This call is recorded.",
                "bSurveyEnabled": "false",
                "Treatment_InQueueActions": "Discover_1stQ_8a_6p_CT~Music::2~Common_2ndQ~Music::2~Loop:3:1~ForceICB~Disconnect",
                "SkillName": "P00095_Premier_Cspro",
                "Treatment_QueueParameters": "",
                "AgentLegInvoked": "YES",
                "COE_Sec_IsAttempted": "true",
                "Language": "English",
                "Debug_CM-Schedule_ClosedStatus": "INFO - Schedule is: open Closed Processing Skipped",
                "TrackingWorkflow": "Triggered",
                "Debug_ImmediateCallbackCM_Status": "Callback to +919666365604 created in queue 00095_Premier_Cspro",
                "QueueName": "00095_Premier_Cspro",
                "Callback_Created_Time_UTC": "2025-09-24T04:43:50.999Z",
                "Treatment_QCAPActions": "Discover_1stQ_8a_6p_CT~Disconnect",
                "Caller_PINV": "U",
                "Schedule_ScheduledCBEnabled": "false",
                "Debug_Verbose": "true",
                "IVR_NOT_Tracked": "Workflow ENV is not matching with Originating IVR Env.",
                "IsSurveyPreQMsgPlayed": "",
                "UDP_GBL_ID": "",
                "eg_km_portalname": "ClientID-00095",
                "Treatment_Parameters": "PadEWT:20|InQEmergChkTimer:300",
                "SetDivisionUpdateWorkflow": "Triggered",
                "GCR_Status": "GC_ANI_Y_REC",
                "Treatment_EmergencyGroups": "",
                "scriptId": "45d0bc96-483a-459b-a4d3-94a6d23b13fd",
                "Debug_InQueue_QCAPViolation": "INFO - No QCAP Violation - Normal Processing",
                "UII_Creation_Status": "Empty - GC Created using API",
                "MORE_IND": "m",
                "Config_DesktopIndicator": "CarePortal",
                "CS_CLIENT_ID": "00095"
            },
            "provider": "Edge",
            "externalContact": {
                "id": "0181f4c7-ef54-4abd-bd15-f03c876c12e1",
                "selfUri": "/api/v2/externalcontacts/contacts/0181f4c7-ef54-4abd-bd15-f03c876c12e1"
            },
            "externalContactInitialDivisionId": "*",
            "peer": "4d500ed5-25a4-4f48-8b98-cbbbba1bde4b",
            "muted": false,
            "confined": false,
            "recording": true,
            "recordingState": "active",
            "ani": "tel:+12242744093",
            "dnis": "tel:+18478869364",
            "securePause": false
        },
        {
            "id": "6f6b0eb4-2180-4fae-a3ea-000f523ae26c",
            "name": "Half Day IL",
            "address": "tel:+919666365604",
            "startTime": "2025-09-24T04:42:08.205Z",
            "connectedTime": "2025-09-24T04:42:08.256Z",
            "endTime": "2025-09-24T04:43:59.235Z",
            "purpose": "customer",
            "state": "terminated",
            "direction": "inbound",
            "disconnectType": "peer",
            "held": false,
            "wrapupRequired": false,
            "mediaRoles": [
                "full"
            ],
            "queue": {
                "id": "9f7d2a94-24c5-4898-9849-4ae3dcfbd558",
                "selfUri": "/api/v2/routing/queues/9f7d2a94-24c5-4898-9849-4ae3dcfbd558"
            },
            "attributes": {
                "GCR_Visibility": "true",
                "Timezone": "US-Central",
                "UIID": "622s",
                "Debug_Inbound_EmergencyCheck": "INFO - No Active Emergency",
                "Debug_Inbound_RoutingLookup": "INFO - Key found in GenRoute Table",
                "Treatment_QCAPThreshold": "EWT:1800",
                "Schedule_CurrentUTCOffset": "-300",
                "Treatment_EmergencyActions": "",
                "AccessDirectCall": "true",
                "GCR_Color": "#FFFF99",
                "Schedule_ActiveScheduleTag": "Default",
                "IS_CS_CUSTOMER_ID_ENCRYPTED": "true",
                "ConversationID": "9a136a7d-0247-4712-80c8-801676a8062a",
                "SKILL_NAME": "",
                "PINV": "",
                "ENC_CS_CUSTOMER_ID": "ufZ//052pP19T6vfwx6CYA==",
                "Debug_InQueue_StartingPIQ": "1",
                "GCR_Ind": "This call is recorded.",
                "Participant_ANI": "",
                "QUEUE_NAME": "",
                "IVR Division Not Updated": "IVR Division Update Workflow ENV is not matching with Originating IVR Env.",
                "ServiceID": "",
                "Callback_Channel": "voice_ASAP",
                "Debug_ImmediateCallbackCM_GetActiveCallbacks": "INFO - 0 active callbacks found",
                "LAST4_ID": "",
                "Schedule_ImmediateCBEnabled": "true",
                "Debug_UUIReceived": "*****45678912341000U00095      m",
                "ScreenPopName": "Inbound Script v2.1",
                "Debug_InQueue_StartingEWT": "Not Available",
                "Key": "+18004898708_1000",
                "GCR_Indicator": "This call is recorded.",
                "bSurveyEnabled": "false",
                "Treatment_InQueueActions": "Discover_1stQ_8a_6p_CT~Music::2~Common_2ndQ~Music::2~Loop:3:1~ForceICB~Disconnect",
                "SkillName": "",
                "Treatment_QueueParameters": "",
                "AgentLegInvoked": "YES",
                "COE_Sec_IsAttempted": "true",
                "Language": "English",
                "Debug_CM-Schedule_ClosedStatus": "INFO - Schedule is: open Closed Processing Skipped",
                "TrackingWorkflow": "Triggered",
                "Debug_ImmediateCallbackCM_Status": "Callback to +919666365604 created in queue 00095_Premier_Cspro",
                "QueueName": "",
                "Callback_Created_Time_UTC": "2025-09-24T04:43:50.999Z",
                "Treatment_QCAPActions": "Discover_1stQ_8a_6p_CT~Disconnect",
                "Caller_PINV": "",
                "Schedule_ScheduledCBEnabled": "false",
                "Debug_Verbose": "true",
                "IVR_NOT_Tracked": "Workflow ENV is not matching with Originating IVR Env.",
                "IsSurveyPreQMsgPlayed": "",
                "UDP_GBL_ID": "",
                "eg_km_portalname": "ClientID-00095",
                "Treatment_Parameters": "PadEWT:20|InQEmergChkTimer:300",
                "SetDivisionUpdateWorkflow": "Triggered",
                "GCR_Status": "GC_ANI_Y_REC",
                "Treatment_EmergencyGroups": "",
                "scriptId": "45d0bc96-483a-459b-a4d3-94a6d23b13fd",
                "Debug_InQueue_QCAPViolation": "INFO - No QCAP Violation - Normal Processing",
                "UII_Creation_Status": "Empty - GC Created using API",
                "MORE_IND": "m",
                "Config_DesktopIndicator": "CarePortal",
                "CS_CLIENT_ID": ""
            },
            "provider": "Edge",
            "externalContact": {
                "id": "0181f4c7-ef54-4abd-bd15-f03c876c12e1",
                "selfUri": "/api/v2/externalcontacts/contacts/0181f4c7-ef54-4abd-bd15-f03c876c12e1"
            },
            "externalContactInitialDivisionId": "*",
            "muted": false,
            "confined": false,
            "recording": false,
            "recordingState": "none",
            "recordersState": {
                "adhocState": "NONE",
                "customerExperienceState": "NONE",
                "agentExperienceState": "NONE"
            },
            "ani": "tel:+12242744093",
            "dnis": "tel:+18478869364",
            "securePause": false
        }
    ],
    "otherMediaUris": [
        "/api/v2/conversations/callbacks/9a136a7d-0247-4712-80c8-801676a8062a"
    ],
   
    "recordingState": "active",
    "securePause": false,
    "selfUri": "/api/v2/conversations/calls/9a136a7d-0247-4712-80c8-801676a8062a"
};
export const ALIS_WEB_MESSAGE_CONVERSATION={
    "id": "18a40063-19dd-47ec-895b-80ff10ae7352",
    "participants": [
        {
            "id": "15467b4f-8162-4713-94ff-60ef69c8e039",
            "startTime": "2025-09-23T13:06:48.233Z",
            "connectedTime": "2025-09-23T13:06:48.233Z",
            "purpose": "customer",
            "state": "connected",
            "direction": "inbound",
            "held": false,
            "wrapupRequired": false,
            "mediaRoles": [
                "full"
            ],
            "queue": {
                "id": "93521256-2d81-4373-abeb-b48b90ce4e37",
                "selfUri": "/api/v2/routing/queues/93521256-2d81-4373-abeb-b48b90ce4e37"
            },
            "attributes": {
                "ChatHistoryUrl": "",
                "Timezone": "US-Eastern",
                "context.Language": "en-US",
                "glblPrsnId": "",
                "DEBUG_Payload_Error": "Token Expired or Bad Payload :",
                "PayloadLabel_10": "",
                "CustSvcCtr_OpenHours": "8 a.m. to 8 p.m. PT, Monday - Friday 5555",
                "CustSvcCtr_TFN": "1-847-999-55555",
                "PPT-NAME": "",
                "personInternalId": "",
                "DEBUG_Message.JourneyContext.customer.id": "b12e0d3a-5d5d-4fc0-9839-f7424aa34211",
                "EMP": "",
                "context.glblPrsnId": "",
                "Client_AEEnrollDates": "",
                "context.firstName": "John",
                "PayloadValue_5": "",
                "firstName": "John",
                "context.ClientID": "",
                "PayloadValue_4": "",
                "PayloadValue_7": "",
                "PayloadValue_6": "",
                "context.lastName": "Doe",
                "PayloadValue_9": "",
                "PayloadValue_8": "",
                "name": "John Doe",
                "Client_EnrollmentType": "",
                "ClientID": "",
                "DEBUG_ExternalContactId": "80eb20d7-3ddd-4303-9fb7-cce6adf3fe5d",
                "PayloadValue_10": "",
                "PayloadValue_1": "NOT AUTHORIZED",
                "PayloadValue_3": "",
                "PayloadValue_2": "",
                "context.gcTokenType": "",
                "lastName": "Doe",
                "context.email": "john.joe@comp.com",
                "PayloadLabel_7": "",
                "PayloadLabel_8": "",
                "PayloadLabel_5": "",
                "PayloadLabel_6": "",
                "PayloadLabel_3": "",
                "Client_AEEffectiveDate": "",
                "context.personInternalId": "",
                "PayloadLabel_4": "",
                "PayloadLabel_1": "MAY BE INTERNAL TEST CALL",
                "PayloadLabel_2": "",
                "CustSvcCtr_Name": "Premier Test Center 5",
                "Language": "en-US",
                "CustSvcCtr_FaxTFN": "1-800-999-55555",
                "email": "john.joe@comp.com",
                "temp": "",
                "CustSvcCtr_PostAddr": "Premier Service Center\n100 Half Day Road\nP.O. Box 12345\nLincolnshire, IL 60069-1455555",
                "DebugMode": "false",
                "ChatTopic": "HW",
                "scriptId": "fd9abb72-8265-482b-8b38-6960c05b4839",
                "jwtPartsLength": "1",
                "PayloadLabel_9": "",
                "PMT": "HW",
                "jwt0": "eyJhbGciOiJSUzUxMiJ9.eyJzdWIiOiJaYXBCcnJsZEFheTNVNEdyYkM2VmMyQTBkS3VkR2cvZEZZSUx3bThBSzF3PSIsImV4cCI6MTczMjIzODkyMCwiaWF0IjoxNzMyMjM4MzIwfQ.KFC3nDs0yixN-6Pb_9z-STRWq-Ph7NNWCsNeiNAw8acIMPKm7herYjjqOQG4_0QrtCTvTN1ieoK1ezeDVxh72-N4tA3ks-ixvaJlQF-GAXZtl5zRU7TWvy0gY1MC1SgNev9lQwXvdJ52ort-G0tgCYKk8HbKZU4Lo4p_6F0A45w8hKyuSboItO-daT4EPpDptT7--55Fn_6GtkdR2uwwo11OLjQ_5rFLMM2HVlwsc5pv4vvLzfx3OLiUTBcptqRnr2Y49Ma19pFUVbmey1elW6FbxI0vk1wHRcBWK1SHb_g3CZoC3vqrFcL24_UBgk24p_goYC27p8peC-ou24Sflg",
                "context.ReqChannelType": "",
                "context.ChatTopic": "HW"
            },
            "provider": "PureCloud Messaging",
            "externalContact": {
                "id": "80eb20d7-3ddd-4303-9fb7-cce6adf3fe5d",
                "selfUri": "/api/v2/externalcontacts/contacts/80eb20d7-3ddd-4303-9fb7-cce6adf3fe5d"
            },
            "externalContactInitialDivisionId": "*",
            "peer": "6d6069b8-4951-4441-9108-da416c8a18a0",
            "journeyContext": {
                "customer": {
                    "id": "b12e0d3a-5d5d-4fc0-9839-f7424aa34211",
                    "idType": "cookie"
                },
                "customerSession": {
                    "id": "251acce0-987e-11f0-a0fc-c10bf9d400c8",
                    "type": "web"
                }
            },
            "toAddress": {
                "name": "Alight_Chat_QC_ENGLISH_24.04.16",
                "addressNormalized": "382d4ae3-5a2b-41db-93b8-773567699b81",
                "addressRaw": "382d4ae3-5a2b-41db-93b8-773567699b81"
            },
            "fromAddress": {
                "addressNormalized": "d01e6cbd-967c-4b9b-be25-52a17592099d",
                "addressRaw": "d01e6cbd-967c-4b9b-be25-52a17592099d"
            },
            "messages": [
                {
                    "messageId": "1d4f2e8765f692580dc733b2de2032ed",
                    "messageURI": "/api/v2/conversations/messages/18a40063-19dd-47ec-895b-80ff10ae7352/messages/1d4f2e8765f692580dc733b2de2032ed",
                    "messageStatus": "received",
                    "messageSegmentCount": 1,
                    "messageTime": "2025-09-23T13:06:48.233Z",
                    "media": [],
                    "stickers": [],
                    "messageMetadata": {
                        "type": "Event",
                        "events": [
                            {
                                "eventType": "Presence",
                                "subType": "Join"
                            }
                        ],
                        "content": []
                    }
                },
                {
                    "messageId": "355bab2345f67d6799eb920d0522acad",
                    "messageURI": "/api/v2/conversations/messages/18a40063-19dd-47ec-895b-80ff10ae7352/messages/355bab2345f67d6799eb920d0522acad",
                    "messageStatus": "received",
                    "messageSegmentCount": 1,
                    "messageTime": "2025-09-23T13:06:49.274Z",
                    "media": [],
                    "stickers": [],
                    "messageMetadata": {
                        "type": "Structured",
                        "events": [],
                        "content": [
                            {
                                "contentType": "ButtonResponse",
                                "subType": "QuickReply"
                            }
                        ]
                    }
                },
                {
                    "messageId": "5850197abf6ac985d1cd41d147444ae2",
                    "messageURI": "/api/v2/conversations/messages/18a40063-19dd-47ec-895b-80ff10ae7352/messages/5850197abf6ac985d1cd41d147444ae2",
                    "messageStatus": "received",
                    "messageSegmentCount": 1,
                    "messageTime": "2025-09-23T13:06:50.365Z",
                    "media": [],
                    "stickers": [],
                    "messageMetadata": {
                        "type": "Structured",
                        "events": [],
                        "content": [
                            {
                                "contentType": "ButtonResponse",
                                "subType": "QuickReply"
                            }
                        ]
                    }
                }
            ],
            "type": "webmessaging"
        },
       
    ],
    "otherMediaUris": [],
  
    "selfUri": "/api/v2/conversations/messages/18a40063-19dd-47ec-895b-80ff10ae7352"
};
export const ALIS_EMAIL_CONVERSATION={};